const state = {
  isLoading: false,
  data: {
    orderable: {},
  },
};

export default state;
